module.exports = __webpack_public_path__ + "assets/1792649897182/img/excel-icon.f896d9cd.png";